import React, { Component } from "react";
import { connect } from "react-redux";
import "react-datetime/css/react-datetime.css";
import CustomScroll from "react-custom-scroll";

import Preloader from "../../../Preloader";
import { Form } from "./Form";

class ContactClientCare extends Component {
  state = {
    sendForm: false,
    isLoading: false,
    noData: false,
  };

  componentDidMount() {
    const { UserProfile } = this.props;
    const systemDetail = {
      contactName: `${UserProfile.firstName} ${UserProfile.surname}`,
      email: UserProfile.email,
      department: UserProfile.department ? UserProfile.department : "",
    };
    this.setState({ systemDetail });
  }

  render() {
    const { _ } = this.props;
    const { systemDetail } = this.state;
    return (
      <>
        <h2 className="ml-3"> {_.ClientForms.ContactClientCare.Title}</h2>
        {this.state.isLoading && <Preloader />}
        <CustomScroll
          heightRelativeToParent={"calc(100% - 50px)"}
          allowOuterScroll={true}
        >
          {systemDetail && (
            <Form
              _={_}
              SystemDetail={this.state.systemDetail}
              sendForm={(payload) => {
                this.setState(payload);
              }}
            ></Form>
          )}
        </CustomScroll>
      </>
    );
  }
}

export const mapStateToProps = ({ _ }) => ({ _ });
export default connect(mapStateToProps)(ContactClientCare);
